import { Navigate, useLocation } from 'react-router-dom';
import { usePermissions } from '@/contexts/PermissionsContext';
import { Lock } from 'lucide-react';

/**
 * Wrap les routes protégées : si le path correspond à un module interdit,
 * affiche un écran "Accès refusé" + bouton retour Dashboard.
 */
export default function ModuleGuard({ children }) {
  const location = useLocation();
  const { isPathBlocked, loaded } = usePermissions();

  if (!loaded) return children;

  const blocked = isPathBlocked(location.pathname);
  if (!blocked) return children;

  return (
    <div className="min-h-[60vh] flex items-center justify-center p-6" data-testid="module-blocked">
      <div className="max-w-md w-full text-center bg-white dark:bg-slate-900 rounded-xl shadow-lg p-8 border border-slate-200 dark:border-slate-800">
        <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center">
          <Lock className="w-8 h-8 text-red-600 dark:text-red-400" />
        </div>
        <h1 className="text-xl font-bold text-slate-900 dark:text-slate-100 mb-2">Accès refusé</h1>
        <p className="text-sm text-slate-600 dark:text-slate-400 mb-6">
          Le module <span className="font-mono font-semibold">{blocked}</span> n'est pas autorisé pour votre profil.
          Contactez votre administrateur si besoin.
        </p>
        <Navigate to="/" replace />
      </div>
    </div>
  );
}
